import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class Title extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (<h3>{this.props.label}</h3>);
  }
}

Title.propTypes = {};

export default Title;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/title.jsx